import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*

// Fáze 2: medailonky s ligovou výkonností. Jména + soupiska z team-profile, výkonnost (aktuální
// sezóna) z team-player-history. Role (admin/kapitán) jsou sgbowling koncept -> zatím statická mapa
// podle bl_player_id (přesune se do sg_profile ve fázi 3). Foto/bio přijdou taky ve fázi 3.

// role podle bl_player_id: "admin" (oprávnění) je oddělené od "captain" (zobrazovací)
val ADMIN_PLAYER_ID = "51dc027f-3188-49d5-a90f-e0cfaa0cea21"   // Bohuslav Macháč ml.
val CAPTAIN_PLAYER_ID = "06508060-7e51-4329-9b96-8b2cb4c3a0e9" // Jan Šika

@Composable
fun PlayersScreen(onOpenPlayer: (String) -> Unit) {
    var profile by remember { mutableStateOf<TeamProfileDto?>(null) }
    var history by remember { mutableStateOf<Map<String, PlayerSeasonStatsDto>>(emptyMap()) }
    var sgProfiles by remember { mutableStateOf<Map<String, SgProfileDto>>(emptyMap()) }
    var error by remember { mutableStateOf<String?>(null) }
    var loading by remember { mutableStateOf(true) }

    LaunchedEffect(Unit) {
        try {
            sgProfiles = runCatching { Api.fetchSgProfiles().associateBy { it.blPlayerId } }.getOrDefault(emptyMap())
            val prof = Api.fetchTeamProfile()
            profile = prof
            // Všechny medailonky musí porovnávat stejnou sezónu. Pokud team-profile aktivní
            // sezónu nezná, vezme se jedna společná nejnovější sezóna z celé historie.
            val playerHistory = Api.fetchTeamPlayerHistory().players
            val activeSeasonId = prof.season?.id
                ?: playerHistory.flatMap { it.seasons }
                    .maxByOrNull { it.seasonName }
                    ?.seasonId
            history = playerHistory
                .mapNotNull { p ->
                    val s = activeSeasonId?.let { id -> p.seasons.find { it.seasonId == id } }
                    s?.let { p.playerId to it }
                }
                .toMap()
        } catch (e: Throwable) {
            error = e.apiMessage()
        } finally {
            loading = false
        }
    }

    when {
        loading -> Div(attrs = { classes("card") }) { P { Text("Načítám…") } }
        profile != null -> {
            val roster = profile!!.roster
            if (roster.isEmpty()) {
                Div(attrs = { classes("card") }) { P(attrs = { classes("muted") }) { Text("Soupiska je prázdná.") } }
            } else {
                Div(attrs = { classes("medallion-grid") }) {
                    // řazení: podle průměru sestupně (hráči bez odehraných her na konec)
                    roster.sortedByDescending {
                        history[it.playerId]?.takeIf { stats -> stats.games > 0 }?.average ?: -1.0
                    }.forEach { player ->
                        Medallion(player, history[player.playerId], sgProfiles[player.playerId], onOpenPlayer)
                    }
                }
            }
        }
        else -> Div(attrs = { classes("card") }) {
            P { Text("Data hráčů se zobrazí po nasazení bowlingliga team API.") }
            error?.let { Div(attrs = { classes("muted") }) { Text("Detail: $it") } }
        }
    }
}

@Composable
private fun Medallion(player: RosterPlayerDto, stats: PlayerSeasonStatsDto?, sgProfile: SgProfileDto?, onOpen: (String) -> Unit) {
    val displayName = sgProfile?.displayName?.takeIf { it.isNotBlank() } ?: player.fullName ?: player.name
    val isCaptain = sgProfile?.isCaptain ?: (player.playerId == CAPTAIN_PLAYER_ID)
    Div(attrs = {
        classes("card", "medallion")
        onClick { onOpen(player.playerId) }
    }) {
        val photo = sgProfile?.photoUrl
        if (!photo.isNullOrBlank()) {
            Img(src = photo, alt = displayName, attrs = { classes("medallion-photo") })
        } else {
            Div(attrs = { classes("avatar-placeholder") }) { Text(displayName.take(1)) }
        }
        H3 { Text(displayName) }
        sgProfile?.nickname?.takeIf { it.isNotBlank() }?.let { Div(attrs = { classes("medallion-nick") }) { Text("„$it“") } }
        Div(attrs = { classes("medallion-roles") }) {
            if (isCaptain) Span(attrs = { classes("badge") }) { Text("kapitán") }
            if (player.playerId == ADMIN_PLAYER_ID) Span(attrs = { classes("badge", "badge-admin") }) { Text("admin") }
        }
        if (stats != null && stats.games > 0) {
            Div(attrs = { classes("medallion-avg") }) { Text("Ø ${stats.average}") }
            Div(attrs = { classes("medallion-sub") }) { Text("${stats.games} her · max ${stats.maxScore}") }
        } else {
            Div(attrs = { classes("medallion-avg") }) { Text("–") }
        }
    }
}
